import Box from '@mui/material/Box'
import {ErrorMessage} from 'formik'

const CustomField = ({name, children, className}) => {
    return(
        <Box className={className} sx={{ width: '100%' }}>
            {children}
            <ErrorMessage name={name} />
        </Box>
    )
}

export default CustomField
